var global = require('../internals/global');

module.exports = global;



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/path.js
// module id = 1193
// module chunks = 0